'use strict';

angular.module('amexReconciliationApp')
  .component('userDefinedField', {
    bindings: {
      field: '<',
      locked: '<',
      userDefinedValues: '=',
      dropdownValues: '&'
    },
    templateUrl: 'scripts/views/directives/user-defined-field.html',
    controller: function($filter,
                         ErrorMessageService,
                         ActiveTransactionModel,
                         dateFormats,
                         UserModel) {
      var self = this;

      self.userDateFormat = dateFormats[(UserModel.currentUser().preferredDateFormat)];

      self.isDatePickerShowing = false;

      self.toggleDatePicker = function () {
        self.isDatePickerShowing = !self.isDatePickerShowing;
      };

      self.activeTransaction = ActiveTransactionModel.activeTransaction();
      self.lastDate = new Date();

      function formatDate(date) {
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var y = date.getFullYear();
        return (m<=9 ? '0' + m : m) + '/' + (d <= 9 ? '0' + d : d) + '/' + y;
      }

      self.modelValue = function(newVal) {
        var value = _.find(self.userDefinedValues, ['udfId', self.field.udfId]) || addNewUdfvalue(self.field);

        switch(self.field.fieldType) {
          case 'DATE':
            if (arguments.length && !_.isEqual(value.value, newVal)) {
              value.value = _.isDate(newVal) ? formatDate(newVal) : newVal === null? '': newVal;
            }
            var date = new Date(value.value);
            if (isNaN(date.getTime())) {
              return value.value;
            }
            if (self.lastDate.getTime() !== date.getTime()) {
              self.lastDate = date;
            }
            return self.lastDate;
          case 'TWO_DECIMAL_NUMBER':
            if (arguments.length && !_.isEqual(value.value, newVal)) {
              value.value = newVal;
            }
            return value.value;
          case 'INTEGER':
            if (arguments.length && !_.isEqual(value.value, newVal)) {
              value.value = validateIntegerInput(newVal);
            }
            return value.value;
          default:
            if (arguments.length && !_.isEqual(value.value, newVal)) {
              value.value = newVal;
            }
            return value.value;
        }
      };

      self.twoDecimalErrorMessage = function (errors) {
        return ErrorMessageService.chooseErrorMessage(errors, {
          'required': 'userDefinedField.errorMessages.RequiredField',
          'currency': 'userDefinedField.errorMessages.InvalidValue',
          'withinUdfNumberRange': 'userDefinedField.errorMessages.ValueOutsideUdfRange'
        });
      };

      function validateIntegerInput(newVal) {
        var prefix = newVal.substr(0,1) == '-' ? '-' : '';

        return prefix + newVal.replace(/[^0-9]/g,'').substr(0,11);
      }

      function addNewUdfvalue(field) {
        var newUdfValue = {
          udfId: field.udfId,
          transactionId: self.activeTransaction.id,
          value: defaultValueForField()
        };
        self.userDefinedValues.push(newUdfValue);
        return newUdfValue;
      }

      function defaultValueForField() {
        if(_.isEqual(self.field.fieldType, 'TWO_DECIMAL_NUMBER')) {
          return '0.00';
        }

        return '';
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/userDefinedField.js
// module id = 543
// module chunks = 0